/**
 * A human-readable message from an API error body.
 *
 * Backend validation failures come as { message: 'Validation failed', errors: { field: [msgs] } }
 * — the generic message alone tells the user nothing (the "0026-11-06 date typo" report). When
 * field errors exist, surface the FIRST one (they are self-explanatory: "The date field must be a
 * date after or equal to 2020-01-01."), noting how many more there are.
 */
export const apiErrorMessage = (data, fallback = 'Something went wrong. Please try again.') => {
  const errors = data?.errors;
  if (errors && typeof errors === 'object') {
    const all = Object.values(errors).flat().filter(Boolean);
    if (all.length > 0) {
      return all.length > 1 ? `${all[0]} (+${all.length - 1} more)` : all[0];
    }
  }
  return data?.message || fallback;
};
